import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { faAngleDown, faArrowDown, faDownload, faEdit } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import {
  getAccessControlAllExcel,
  getAccessControlAllPdf,
  getAccessControlList,
  putAccessControlStatus,
} from "../../../Service/AllAccessControlAPI";

import AccessControlForBackOffice from "./AccessControlForBackOffice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import swal from "sweetalert";

export default () => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [entries, setEntries] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [statusChange, setStatusChange] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);

  //Pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const toggleTrueFalse = () => {
    setShowModal(handleShow);
  };

  useEffect(() => {
    getBackOfficeList();
  }, []);

  useEffect(() => {
    putBackOfficeStatus();
  }, [selectedStatus]);
// Function of get pagination
  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
   // setisLoaded(true);
    await getAccessControlList(selectedPage, "back office", headers)
      .then((result) => {
        console.log("Get Pagination Back Office Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          console.log("data", data);
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          entries.map((item, index) => (item.id = totalSize + index + 1));
          setisLoaded(false);
        } else {
          setEntries([]);
          setPageCount();
          setTotalCount();
          setisLoaded(false);
        }
      })
      .catch((error) => console.error("Error", error));
    console.log("entries", entries);
    console.log("page", page);
  };
  // Function declaration of get BackOffice list
  const getBackOfficeList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      setisLoaded(true);
      await getAccessControlList(currentPage, "back office", headers)
        .then((result) => {
          
          console.log("Get Access Control List of Back Office Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            swal("Sorry", "Back office data is not present", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Access Control List of Back Office Error", error);
        });
        setisLoaded(false);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };
// Function of pdf download
  const getBackOfficePdfDownload = async () => {
    let re = "back office";
    try {
      setisLoaded(true);
      await getAccessControlAllPdf(re);
      setisLoaded(false);
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal( "Sorry", "Back Office Data is empty ", "warning" );
    }
  };
// Function of pdf download
  const getBackOfficeExcelDownload = async () => {
    let re = "back office";
    try {
      await getAccessControlAllExcel(re)
    } catch (error) {
      console.log("error :-", error);
      swal( "Sorry", "Back Office Data is empty ", "warning" );
    }
  }
  // Function of status update
  const putBackOfficeStatus = async () => {
    try {
      if (statusChange?.length !== 0) {
        await putAccessControlStatus(
          statusChange.pkAccessControlId,
          statusChange.status
        )
          .then((result) => {
            console.log("Back Office Result", result);
            swal("Great", "Back Office status updated successfully", "success");
            getBackOfficeList();
          })
          .catch((error) => {
            console.log("Back Office Error", error);
            swal(
              "Failed",
              "Something went wrong please check your internet",
              "error"
            );
          });
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };
  // column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
// Column heading of back office list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
      },
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "active",
            label: "Active",
          },
          {
            value: "deactive",
            label: "Deactive",
          },
        ],
      },
      formatter: (cell) => {
        return (
          <>
            <div className="content-cell">
              <span>{cell}</span>
            </div>
            <div className="dropDown">
              <div className="moduleFieldDropDown">
                <FontAwesomeIcon icon={faAngleDown} />
              </div>
            </div>
          </>
        );
      },
    },
    {
      dataField: "userName",
      text: "User Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "mobileNumber",
      text: "Mobile No",
      editable: false,
      headerAlign: "left",
    },
   
    {
      dataField: "moduleName",
      text: "Module",
      editable: false,
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
        width: "45%",
        whiteSpace: "nowrap",
      },
      formatter: (cell) => {
        const label = Array.isArray(cell) ? cell.join(", ") : cell;
        return (
          <div className="content-cell access-control-module-cell">
            <span>{label}</span>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      headerAlign: "center",
      headerStyle: { width: "110px" },
      style: { whiteSpace: "nowrap", width: "110px", minWidth: "110px" },
      formatter: (cell, row) => (
        <button
          type="button"
          className="btn btn-sm btn-primary access-control-action-btn"
          onClick={() => {
            setSelectedRow(row);
            toggleTrueFalse();
          }}
        >
          Edit Access
        </button>
      ),
      editable: false,
      csvExport: false,
    },
  ];

  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
    {isLoaded ? (
      <div className="reportload"></div>
    ) : (
    <>
      {show && (
        <AccessControlForBackOffice
          status={show}
          handleClose={handleClose}
          rowData={selectedRow}
        />
      )}
      <ToolkitProvider
        keyField="id"
        search={true}
        columns={columns}
        data={entries}
        exportCSV={{ onlyExportFiltered: true, exportAll: true,fileName: 'backOfficeView.csv', }}
      >
        {({ baseProps, searchProps, csvProps }) => (
          <Paginator.PaginationProvider
            pagination={Pagination({
                custom: true,
              disablePageTitle: true,
              alwaysShowAllBtns: true,
              totalSize: totalCount,
              paginationTotalRenderer: customTotal,
              onPageChange : handlePageChange,
            })}
          >
            {({ paginationProps, paginationTableProps }) => (
              <Card>
                <div className="table-responsive py-2">
                  <Card.Header>
                    <Row>
                      <Col xs={12} md={6} className="py-1">
                        {/* <Paginator.SizePerPageDropdownStandalone
                          {...paginationProps}
                        /> */}
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        className="d-flex justify-content-md-end py-1"
                      >
                        {/* <Search.SearchBar {...searchProps} /> */}
                        {/* <ExportCSVButton
                          {...csvProps}
                          className="btn btn-secondary mx-2"
                        >
                          <span>CSV</span>{" "}
                        </ExportCSVButton> */}
                        <button
                          className="btn btn-secondary mx-2"
                          onClick={getBackOfficePdfDownload}
                        >
                          <FontAwesomeIcon icon={faDownload} className="me-2" />
                          <span>PDF</span>{" "}
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={getBackOfficeExcelDownload}
                        >
                          <FontAwesomeIcon icon={faDownload} className="me-2" />
                          <span>Excel</span>
                        </button>
                      </Col>
                    </Row>
                  </Card.Header>

                  <Table
                    {...baseProps}
                    {...paginationTableProps}
                    bodyClasses="border-0"
                    rowClasses="border-bottom"
                    classes="table-flush dataTable-table"
                    wrapperClasses="table-responsive"
                    filter={filterFactory()}
                    remote= {{pagination:true}}
                    headerClasses="header-class"
                    hover
                    striped
                    condensed
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                      afterSaveCell: (oldValue, newValue, row, column) => {
                        setStatusChange(row);
                        setSelectedStatus(newValue);
                      },
                    })}
                    //selectRow={selectRow}
                  />
                  <Card.Footer>
                    <Row>
                      <Col
                        xs={12}
                        md={6}
                        className="d-flex align-items-center py-1"
                      >
                          {/* <Paginator.PaginationTotalStandalone
                          {...paginationProps}
                        /> */}
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                      >
                        <Paginator.PaginationListStandalone
                          {...paginationProps}
                        />
                      </Col>
                    </Row>
                  </Card.Footer>
                </div>
              </Card>
            )}
          </Paginator.PaginationProvider>
        )}
      </ToolkitProvider>
    </>
    )}
    </>
  );
};
